import { render, staticRenderFns } from "./DefaultImageViewer.vue?vue&type=template&id=1f155b19&"
import script from "./DefaultImageViewer.vue?vue&type=script&lang=js&"
export * from "./DefaultImageViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports